/* Info Component on the ScheduleDays component */
import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import styles from "../../styles/Callsheets.module.css";

const Info2 = () => {
  return (
    <div className='pb-0 mb-3'>
        <Row >
            <Col className={`text-center px-3 py-2 ${styles.SubTitle6 }`}
             md={{span: 10, offset: 1 }}>
              <p className={`${styles.Red} text-center`}>2ND UNIT SCHEDULE INFO</p>
              <hr className={`mt-2 mb-0`}/>
            <p className='mt-2'>
                  <span className={`${styles.Red}`}>*</span> Create <span className={`${styles.Red}`}>Shoot Days</span>, then click on a Day to view or add Stripboards. 
                </p>
                <hr className={`mt-2 mb-0`}/>
            </Col>
        </Row>
    </div>
  )
}

export default Info2